const t = {
  fontFamily: ['"Noto Sans"', 'sans-serif'].join(','),
  body1: {
    fontFamily: ['"Noto Sans"', 'sans-serif'].join(','),
  },
};

export default t;
